<template>
  <form name="plan" class="needs-validation" novalidate>
    <div
      id="alert"
      class="alert alert-dismissible fade show m-alert m-alert--outline mb-4 mt-4"
      :class="alert.color"
      role="alert"
      v-if="alert.message"
      ref="alert"
    >
      <button type="button" class="close" aria-label="Close" @click="alert.message = ''"></button>
      <i :class="alert.icon"></i> &nbsp;<strong>{{ alert.message }}</strong
      ><br />
      {{ alert.reason }}
    </div>
    <label>Motivo da alteração <span class="m--font-danger">*</span></label>
    <input
      type="text"
      ref="change_reason"
      class="form-control"
      maxlength="255"
      v-model="data.change_reason"
      placeholder="Motivo da alteração"
    />
    <hr />
    <div class="row">
      <div class="col-md-2">
        <div class="form-group">
          <label for="plan_id"> ID Plano </label>
          <div class="input-group">
            <input type="number" class="form-control m-input" v-model="data.id" readonly />
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group" :class="{ 'has-danger': !data.product_id }">
          <label>Produto <span v-if="!data.id" class="m--font-danger">*</span></label>
          <div class="input-group">
            <SelectProducts
              ref="product_id"
              :selected="data.product_id"
              :first="'Selecione um produto'"
              @change="data.product_id = $event"
              :disabled="data.id"
              :productsNotAppear="[2, 3, 4, 5, 6]"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-md-12">
        <div class="form-group" :class="{ 'has-danger': !data.name }">
          <label for="name">Nome <span v-if="!data.id" class="m--font-danger">*</span></label></label>
          <div class="input-group">
            <input id="name" type="text" class="form-control" placeholder="" v-model="data.name" />
          </div>
        </div>
      </div>
    </div>

    <hr class="row mt-5 mb-3" />
    <div class="row">
      <div class="col-md-12 text-right">
        <p class="p-0 m-0">
          <a
            href="#"
            @click.prevent="$refs.change_reason.focus()"
            target="_self"
            class="m--font-danger"
            v-if="!data.name"
            >O campo <strong>Nome</strong> é obrigatório *</a
          >
        </p>
        <p class="p-0 m-0">
          <a
            href="#"
            @click.prevent="$refs.product_id.$el.focus()"
            target="_self"
            class="m--font-danger"
            v-if="!data.product_id"
            >O campo <strong>Produto</strong> é obrigatório *</a
          >
        </p>
        <p class="p-0 m-0">
          <a
            href="#"
            @click.prevent="$refs.change_reason.focus()"
            target="_self"
            class="m--font-danger"
            v-if="!data.change_reason"
            >O campo <strong>Motivo da alteração</strong> é obrigatório *</a
          >
        </p>
      </div>
    </div>
    <div class="row mb-5">
      <div class="col-md-12 text-right">
        <button
          @click.prevent="saveForm()"
          class="btn"
          :class="{ 'btn-metal': !formIsValid, 'btn-focus': formIsValid }"
          :disabled="!formIsValid || loading"
        >
          <i class="fas fa-save" v-if="formIsValid"></i>
          <i class="fas fa-exclamation-triangle" v-else></i>
          Salvar
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import SelectProducts from '@/components/forms/SelectProducts';
import { returnMessageFormMixin } from '@/mixins/returnMessageFormMixin';

import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  mixins: [returnMessageFormMixin],
  name: 'PlanSaveForm',
  components: { SelectProducts },
  props: {
    plan: {
      type: Object,
    },
    changeReason: String,
  },
  data() {
    return {
      data: {},
      loading: false,
    };
  },
  methods: {
    async saveForm() {
      await this.messageWaitingSave();

      const alertEl = this.$refs.alert;

      if (alertEl) {
        alertEl.scrollIntoView();
      }

      const { data } = this;
      this.loading = true;
      const url = `${baseApiUrl}/v1/plans/save`;
      axios
        .post(url, data)
        .then((res) => {
          this.logMessageForm(res);
          this.$store.state.showPlanSave = res.data.item.id;
          this.$emit('savedPlan', res.data.item);
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.logMessageFormFailed(error.response);
        });
    },
  },
  computed: {
    planId() {
      return this.$store.state.showPlanSave;
    },
    formIsValid() {
      if (this.data.product_id && this.data.name && this.data.change_reason) {
        return true;
      }
      return false;
    },
  },
  beforeMount() {
    if (this.planId === 'add') {
      this.data = {
        product_id: 0,
        name: '',
        change_reason: '',
      };
    }
  },
  watch: {
    plan(newPlan) {
      this.data = newPlan;
    },
    changeReason() {
      this.data.change_reason = this.changeReason;
    },
  },
};
</script>

<style></style>
